import * as React from "react";
import { useRef, useEffect, useState } from "react";
import { connect, RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  DetailsListLayoutMode,
  IColumn,
  Selection,
} from "office-ui-fabric-react/lib/DetailsList";
import { MarqueeSelection } from "office-ui-fabric-react/lib/MarqueeSelection";
import { ShimmeredDetailsList, Stack } from "office-ui-fabric-react";
import { IClientsListProps } from "../models/ClientsListTypes";
import { listContainerS, listS, footer } from "./clientsList.styles";
import Pagination from "../providers/Pagination";
import { IRenderProps } from "../../orders/providers/Pagination.types";
import { inActiveClientsColumns } from "./colums/inActiveClientsColumns";
import { activeClientsColumns } from "./colums/clients-columns";
import { toggleClientsPanel } from "../../../config/redux/clients/panel/clientPanelActions";
import {
  setActiveClient,
  setClients,
} from "../../../config/redux/clients/clientsActions";
import { NavigationPath } from "../../../config/routing/NavigationPath";
import { sort, toggleFiltration } from "../../../config/redux/filters/filterActions";
import { setSelectedClients } from "../actions/clientList";

const ClientsList: React.FC<IClientsListProps> = ({ pathname, isPanelOpen }) => {
  const { t } = useTranslation("admin");
  const dispatch = useDispatch();
  const { selectedClients, reload } = useSelector((state: RootStateOrAny) => state.clients);

  const columns = pathname === NavigationPath.INACTIVE_CLIENTS
    ? inActiveClientsColumns(t)
    : activeClientsColumns(t);

  const [cols, setCols] = useState<IColumn[]>(columns);
  const footerRef = useRef<HTMLDivElement>(null);

  const selection = useRef(new Selection({
    onSelectionChanged: () => {
      const items = selection.current.getSelection();
      const ids = items.map((item: any) => item.id);
      dispatch(setClients({ selectedClients: [...ids] }));
    },
  }));

  useEffect(() => {
    setCols(pathname === NavigationPath.INACTIVE_CLIENTS
      ? inActiveClientsColumns(t)
      : activeClientsColumns(t));
  }, [t, pathname]);

  useEffect(() => {
    if (reload || !selectedClients[0]) {
      selection.current.selectToKey("", true);
    }
  }, [reload, selectedClients]);

  useEffect(() => {
    return () => {
      dispatch(setSelectedClients({ selectedClients: [] }));
    };
  }, []);

  const onItemInvoked = (item: any) => {
    dispatch(setActiveClient({ activeClient: item }));
    dispatch(toggleClientsPanel(true));
  };

  const onColumnHeaderClick = (_: any, column: any) => {
    if (column.key === "receptionPlacesOrderTypes") return;

    const newColumns = cols.slice();
    const currColumn = newColumns.find(c => c.key === column.key)!;
    newColumns.forEach(col => {
      if (col === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
      } else {
        col.isSorted = false;
        col.isSortedDescending = true;
      }
    });

    dispatch(toggleFiltration({ filter: true }));
    dispatch(sort({ column: currColumn }));
    setCols(newColumns);
  };

  return (
    <>
      <Pagination
        footerRef={footerRef}
        render={({ data, loading }: IRenderProps) => (
          <>
            <Stack styles={listContainerS}>
              <MarqueeSelection isEnabled={!isPanelOpen} selection={selection.current}>
                <ShimmeredDetailsList
                  items={data}
                  columns={cols}
                  setKey="items"
                  layoutMode={DetailsListLayoutMode.justified}
                  selection={selection.current}
                  selectionPreservedOnEmptyClick={true}
                  onItemInvoked={onItemInvoked}
                  usePageCache={true}
                  styles={listS}
                  onColumnHeaderClick={onColumnHeaderClick}
                  enableShimmer={loading}
                />
              </MarqueeSelection>
            </Stack>
            <div className={footer} ref={footerRef} />
          </>
        )}
      />
    </>
  );
};

export default ClientsList;